// extracted by mini-css-extract-plugin
module.exports = {"actions":"_6821","red":"_10522","hidden":"_10051"};